(function () {
    "use strict";

    angular
      .module("virtualFairs")
      .controller(
        "VirtualFairEventNumbersController",
        VirtualFairEventNumbersController
      );
      VirtualFairEventNumbersController.$inject = [
        "VirtualFairService",
      ];

    function VirtualFairEventNumbersController(VirtualFairService)
    {
      var vm = this;
      vm.getVirtualFairs = getVirtualFairs;
      vm.getByFilter = getByFilter;
      vm.queryFlag = false;
      vm.virtualFairSelected = -1;
      vm.eventExhibitorsCount = 0;
      vm.eventRepresentativesCount = 0;
      vm.eventStudentsCount = 0;

      function getVirtualFairs() {
        vm.query = {};
        VirtualFairService.getAll(vm.query).then(function (response) {
          vm.virtualFairs = response.data;
          vm.virtualFairSelected = -1;
        });
      }

      function getByFilter() {
        vm.queryFlag = false;
        vm.query = {};
        if (vm.virtualFairSelected) {
          vm.query["virtual_fair_id"] = vm.virtualFairSelected;
        }

        VirtualFairService.getEventNumbers(vm.query).then(function(response) {
            vm.platform = response.data.virtualFair.platform_prefix;
            vm.eventName = response.data.virtualFair.title;
            vm.eventExhibitorsCount = response.data.eventExhibitorsCount;
            vm.eventRepresentativesCount = response.data.eventRepresentativesCount;
            vm.eventStudentsCount = response.data.eventStudentsCount;
            vm.eventStudentsConfirmedCount = response.data.eventStudentsConfirmedCount;
            vm.queryFlag = true;
        });

      }

      function active() {
        vm.getVirtualFairs();
      }

      active();
    }
  })();
